<template>
    <div>
        <b-modal
            id="modalAnexoForm"
            v-model="mostrarModal"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Pagamento - Anexo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexosSelect"
                            v-model="tipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                    </b-form-group>
                    <b-alert show v-if="tipo && tipo.ajuda">{{
                        tipo.ajuda
                    }}</b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-input
                            type="text"
                            placeholder="Descritivo"
                            v-model="descritivo"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O descritivo do anexo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharAnexoForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarAnexo()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'pagamento-anexo-form',

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'INSERIR',
            erros: [],
            obterPagamentoAtualizado: false,
            tiposAnexosSelect: [],
            tipoId: '',
            descritivo: '',
            arquivo: null
        }
    },

    methods: {
        fecharAnexoForm() {
            this.mostrarModal = false
            this.resetAnexoForm()
            if (this.obterPagamentoAtualizado) {
                this.$emit('obterPagamentoAtualizado')
            }
        },

        resetAnexoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterPagamentoAtualizado = false
        },

        salvarAnexo() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')
            let anexoData = {
                pagamentoId: this.pagamento.pagamentoId,
                tipoId: this.tipoId,
                descritivo: this.descritivo,
                arquivo: this.arquivo
            }
            this.pagamentosServicos
                .inserirPagamentoAnexo(anexoData)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterPagamentoAtualizado = true
                            this.resetAnexoForm()
                            this.fecharAnexoForm()
                        } else {
                            this.erros = response.errors
                            this.mostrarModal = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterAnexosTipos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterAnexosTipos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexosSelect = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexosSelect.find(
                (p) => p.anexoTipoId == this.tipoId
            )
            return tiposTemp ? tiposTemp : {}
        },

        acessoRotaFornecedor() {
            return this.$temAcesso('SGTEC-FORN-PAG-03') 
                && this.$route.name == 'Sgtec_Fornecedor_Pagamentos_Detalhar' 
        },

        acessoRotaUABS() {
            return this.$temAcesso('SGTEC-PAG-ANX-01') 
                && this.$route.name == 'Sgtec_Uabs_Pagamentos_Detalhar' 
        }
    },

    created() {
        if (
            this.acessoRotaFornecedor 
            || this.acessoRotaUABS
        ) {
            this.obterAnexosTipos()
        }
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            required
        },
        descritivo: {
            required
        }
    }
}
</script>
